import React, { useEffect } from 'react';
import { SiteHeader } from './components/SiteHeader';
import { TruckHero } from './components/TruckHero';
import { SpecialOffers } from './components/SpecialOffers';
import { MenuSection } from './components/MenuSection';
import { SiteFooter } from './components/SiteFooter';
import { business } from './data/business';
export function App() {
  useEffect(() => {
    document.title = `${business.name} | Street Tacos in Las Vegas`;
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans text-ink selection:bg-salsa selection:text-white" data-id="element-0" data-mp="2riknh5rqsbbj">
      <SiteHeader data-id="element-1" data-mp="31aqfgfhzusqq" />
      <main data-id="element-2" data-mp="31b8lu4ydencd">
        <TruckHero data-id="element-3" data-mp="31bs27h8dh3oa" />
        <SpecialOffers data-id="element-4" data-mp="31c9vq63nh3si" />
        <MenuSection data-id="element-5" data-mp="31ctaxf1x1e2u" />
      </main>
      <SiteFooter data-id="element-6" data-mp="2wjgpfdsj9neb" />
    </div>;
}